var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1.41577 1.3749L1.55566 1.34035C1.77499 1.28612 1.92381 1.43369 2.69116 2.22146C3.07221 2.61245 3.54628 3.09905 3.98828 3.48745L4.0105 3.5093C4.24357 3.77083 4.5097 4.01066 4.72388 4.20363C4.88958 4.35236 5.0304 4.48058 5.12231 4.58339L5.16113 4.66274C5.46483 4.35398 5.90076 3.89742 6.35913 3.41689C8.39468 1.2831 8.4115 1.27766 8.60132 1.31521L8.78809 1.38137L8.82202 1.52114C8.8756 1.73982 8.71721 1.90171 7.86646 2.72292C7.44461 3.13025 6.91993 3.63666 6.47949 4.12526C6.19939 4.38123 5.93783 4.67009 5.72754 4.90261C5.57238 5.07357 5.43899 5.22019 5.33301 5.31862L5.21045 5.38552L5.11328 5.3865L4.94507 5.38051L4.87183 5.25417C4.85614 5.22758 4.84238 5.19351 4.83789 5.1531L4.82666 5.15798L4.70605 5.0458C4.12752 4.50642 3.51136 3.90839 2.76782 3.16384C2.30036 2.69917 1.85504 2.23354 1.41748 1.77504L1.31641 1.66982L1.41577 1.3749Z",
    fill: "#18376D",
    stroke: "#18376D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.0575002607681b9836c02e1fe1a3361b.svg";
export { ForwardRef as ReactComponent };